import _ from '@lodash';
import * as yup from 'yup';
import { useTranslation } from 'react-i18next';
import { useWorkflow } from '../../WorkflowProvider';
import { TransComponentTitleField, TransFeatureColumnField, TransInputFieldsPropertiesArray, TransInputKeysField, TransNameField, TransOutputKeyField, TransValidationIOKey, TransValidationName } from '../TransformationProperties';
import TransformationPropertiesDialog from '../TransformationPropertiesDialog';
import { converter } from './JoinStreamsTransformation';

function JoinStreamsProperties(props) {
	const { data, showPropertiesDialog, transformationNameAvailable } = useWorkflow();
	const { t } = useTranslation(['transformer', 'validation']);
	const item = data.transform.find(d => d.key === showPropertiesDialog.key);

	const schema = yup.object().shape({
		name: TransValidationName(transformationNameAvailable, item.key),
		input_keys: yup.array().min(1, t('validation:AT_LEAST_ONE_REQUIRED')).required(t('validation:FIELD_REQUIRED')),
		output_fields: TransValidationIOKey()
	});

	return (
		<TransformationPropertiesDialog schema={schema} converter={converter} titleKey="joinStreamsProperties">
			<TransNameField />
			<TransInputKeysField />
			<TransInputFieldsPropertiesArray type="Components" />
			<TransOutputKeyField />
			<TransFeatureColumnField />
			<TransComponentTitleField />
		</TransformationPropertiesDialog>
	);
}
export default JoinStreamsProperties;
